import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import moment from 'moment';
import { ToolbarModule } from 'primeng/toolbar';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { CurrentUserService, LayoutService } from '@shared/services';
import { CurrentUser } from '@shared/types';
import { NgOptimizedImage } from '@angular/common';
import { ToolbarComponent } from '@layout/toolbar/toolbar.component';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: true,
    imports: [ToolbarModule, TranslateModule, RouterLink, ToolbarComponent, NgOptimizedImage],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
    private layoutService = inject(LayoutService);
    private currentUserService = inject(CurrentUserService);

    isSidebarCollapsed = signal<boolean>(true);
    currentUser = signal<CurrentUser | null>(this.currentUserService.currentUser());
    welcomeMessage = signal<string>(this.computeWelcomeMessage());

    constructor() {
        this.layoutService.isSidebarCollapsed$.subscribe(isCollapsed => {
            this.isSidebarCollapsed.set(isCollapsed);
        });
    }

    private computeWelcomeMessage(): string {
        const now = moment();
        const startOfDay = now.clone().startOf('day');
        const endOfMorning = startOfDay.clone().hour(11).minute(59).second(59);
        const endOfAfternoon = startOfDay.clone().hour(15).minute(59).second(59);
        const endOfEvening = startOfDay.clone().hour(23).minute(59).second(59);

        if (now.isBetween(startOfDay, endOfMorning, null, '[]')) {
            return 'header.goodMorning';
        }
        if (now.isBetween(endOfMorning, endOfAfternoon, null, '[]')) {
            return 'header.goodAfternoon';
        }
        if (now.isBetween(endOfAfternoon, endOfEvening, null, '[]')) {
            return 'header.goodEvening';
        }

        return 'header.welcome';
    }
}
